import classNames from 'classnames'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { useContentOverflow, useDateLocale, useTimeZone } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { getCalendarGridChipTitle } from '../CalendarGrid.utils'
import { getCalendarGridTimeRangeLabel } from '../CalendarGrid.utils.time'

import { QA_NAME_CALENDAR_GRID_CHIP } from './CalendarGridChip.constants'
import { getCalendarGridChipTooltip } from './CalendarGridChip.utils'

import * as styles from './CalendarGridChip.module.css'

function CalendarGridChip({
  className = styles.CalendarGridChip,
  elementRef,
  item = EMPTY_OBJECT,
  onClick,
  onClickItem,
  ...restProps
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { end, hint, id, isAllDay, isDisabled, start, tooltip, variant } = item

  const title = getCalendarGridChipTitle(item)

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [title],
  })

  function handleClick(event) {
    onClick?.(event)

    onClickItem?.(item, event)
  }

  return (
    <FloatingTooltip
      content={getCalendarGridChipTooltip({
        hasTitleOverflow: overflow,
        hint,
        title,
        tooltip,
      })}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <div
        {...restProps}
        {...getQaSelector({ context: id, value: QA_NAME_CALENDAR_GRID_CHIP })}
        className={classNames(className, styles[variant], {
          [styles.disabled]: isDisabled,
        })}
        ref={elementRef}
        onClick={handleClick}
      >
        {isAllDay ? null : (
          <Text className={styles.time}>
            {getCalendarGridTimeRangeLabel({ end, locale, start, timezone })}
          </Text>
        )}
        <Text className={styles.title} ref={setContentOverflowRef}>
          {title}
        </Text>
      </div>
    </FloatingTooltip>
  )
}

export default CalendarGridChip
